const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const roundMoney = (value) => Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;

export const getJobCostMaterialMarkupPercent = (item) => {
  // Backup before T&M material markup fix:
  // return toNumber(item?.markup_percent ?? item?.material_markup_percentage ?? item?.product_markup ?? item?.retail_price ?? item?.markup ?? 0);
  const values = [
    item?.markup_percent,
    item?.material_markup_percentage,
    item?.product_markup,
    item?.retail_price,
    item?.markup
  ];
  const firstPositiveMarkup = values.find((value) => toNumber(value) > 0);
  return toNumber(firstPositiveMarkup ?? 0);
};

/** Product formula qty for Expected vs Actual (non-T&M). */
export const getCompareExpectedMaterialQty = (item) =>
  toNumber(item?.jobcost_actual_quantity ?? item?.quantity ?? item?.jobcost_quantity ?? 0);

export const getCompareExpectedMaterialUnitCost = (item) =>
  toNumber(
    item?.jobcost_actual_unit_cost ??
      item?.actual_unit_price ??
      item?.unit_cost ??
      item?.jobcost_unit_cost ??
      item?.unit_price ??
      0
  );

/** Recipe materials on Expected budget — use formula qty, not job-cost actual qty. */
export const includeMaterialOnCompareExpectedBudget = (material, isTM = false) => {
  // Backup before T&M sales order material expected fix:
  // if (!material || isTM) return false;
  if (!material) return false;
  if (material.notFromRecipe == true) return false;
  if (isTM) {
    const expectedQty = toNumber(material?.jobcost_actual_quantity ?? material?.quantity ?? 0);
    return expectedQty > 0;
  }
  return getCompareExpectedMaterialQty(material) > 0;
};

export const getJobCostMaterialCost = (item, isTM = false, options = {}) => {
  if (!item) return 0;
  const qty = toNumber(
    options.qty ??
      item.jobcost_quantity ??
      item.quantity ??
      item.location_quantity ??
      item.jobcost_actual_quantity ??
      0
  );
  const unitCost = toNumber(
    options.unitCost ??
      item.jobcost_unit_cost ??
      item.unit_price ??
      item.unit_cost ??
      item.actual_unit_price ??
      item.jobcost_actual_unit_cost ??
      item.product_retail_price ??
      item.price ??
      0
  );
  const markupMultiplier = isTM ? 1 + getJobCostMaterialMarkupPercent(item) / 100 : 1;
  const calculatedTotal = roundMoney(qty * unitCost * markupMultiplier);
  const hasExplicitInputs = options.qty !== undefined || options.unitCost !== undefined;

  if (hasExplicitInputs || isTM) {
    return calculatedTotal;
  }

  const savedTotal = item.jobcost_total ?? item.total ?? item.jobcost_total_cost;
  if (savedTotal !== null && savedTotal !== undefined && savedTotal !== '') {
    const saved = roundMoney(savedTotal);
    // Keep persisted totals only while quantity × unit rate still matches (unchanged row).
    if (Math.abs(saved - calculatedTotal) < 0.01) {
      return saved;
    }
  }

  return calculatedTotal;
};

/** Sync row totals after quantity edits so state matches quantity × unit rate (+ T&M markup). */
export const getJobCostMaterialRowTotals = (item, isTM = false, qtyOverride) => {
  const unitCost =
    item?.inhouse == 0 || item?.inhouse === '0'
      ? 0
      : toNumber(item?.unit_cost ?? item?.unit_price ?? item?.jobcost_unit_cost ?? 0);
  const qty = qtyOverride ?? item?.quantity ?? 0;
  const total = getJobCostMaterialCost(item, isTM, { qty, unitCost });
  return { total, jobcost_total: total, jobcost_total_cost: total };
};
